import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { Container } from '@rxdi/core';
import { css } from '@rxdi/lit-html';
import { DynamicCssService } from '@rxdi/ui-kit/services';
export const DarkModeCSS = css`
  :root {
    --global-color: white;
    --global-background: #292c30;
    --global-background-image: linear-gradient(#292c30, #24292f);
    --menu-profile-border-color: white;
    --global-dropdown-menu-bg: white;
    --card-list-bg-color: #e2e4e6;
    --card-container-bg-color: #fff;
    --notification-icon-fill: #fff;
    --menu-profile-border-color: #949494;

    --tabs-menu-hover-color: rgba(255, 255, 255, 1);
    --bx-dropdown-text-color: white;
    --avatar-size: 1.7rem;
    --avatar-count: 5;
    --spinner-stroke-color: currentColor;
  }
`;
export const LightModeCSS = css`
  :root {
    --global-color: rgb(3, 25, 63);
    --global-background: #f7f7f7;
    --global-background-image: linear-gradient(#ffffff, #e7e7e7);
    --global-dropdown-menu-bg: var(--global-background, white);
    --card-list-bg-color: #fcfcfc;
    --card-container-bg-color: #f0f0f0;
    --notification-icon-fill: #44a7ef;
    --menu-profile-border-color: #949494;

    --tabs-menu-hover-color: rgba(255, 255, 255, 1);
    --bx-dropdown-text-color: white;
    --avatar-size: 1.7rem;
    --avatar-count: 5;

    --spinner-stroke-color: currentColor;

    /* @vaadin components themes */
    --lumo-contrast-10pct: white;
    --lumo-contrast-20pct: #ededed;
  }
`;

export const palettes = {
  danger: css`
    :root {
      --danger-bg-color: #f2492c;
      --danger-color: #fff;
      --danger-border: 1px solid transparent;
      --danger-hover-color: #d64127;
      --danger-active-color: #bb3a24;
      /* Test css */
      --blue: #0e86ca;
      --indigo: #6610f2;
      --purple: #8410ba;
      --pink: #f0f;
      --red: #930304;
      --orange: #e28b00;
      --yellow: #e28b00;
      --green: #18a006;
      --teal: #20c997;
      --cyan: #17a2b8;
      --white: #fff;
      --gray: #6c757d;
      --gray-dark: #343a40;
      --primary: #0e86ca;
      --secondary: #1c2534;
      --success: #18a006;
      --info: #17a2b8;
      --warning: #e28b00;
      --danger: #930304;
      --light: #f8f9fa;
      --dark: #343a40;
      --breakpoint-xs: 0px;
      --breakpoint-sm: 321px;
      --breakpoint-md: 576px;
      --breakpoint-lg: 961px;
      --breakpoint-xl: 1401px;
      --font-family-sans-serif: 'Open Sans', Helvetica, Arial, sans-serif;
      --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
    }
  `,
  default: css`
    :root {
      --default-bg-color: white;
      --default-color: #222;
      --default-border: 1px solid #e5e5e5;
      --default-hover-color: #bbbbbb;
      --default-hover-border: 1px solid #bbbbbb;
      --default-active-color: #8a8a8a;
    }
  `,
  primary: css`
    :root {
      --primary-bg-color: #359ec0;
      --primary-color: #fff;
      --primary-border: 1px solid transparent;
      --primary-hover-color: #2e86a3;
      --primary-active-color: #29738b;
    }
  `,
  root: css`
    :root {
      --bp-s: 640px;
      --bp-m: 960px;
      --bp-l: 1200px;
      --bp-xl: 1600px;
    }
  `,
  secondary: css`
    :root {
      --secondary-bg-color: #222;
      --secondary-color: #fff;
      --secondary-border: 1px solid transparent;
      --secondary-hover-color: #333;
      --secondary-active-color: #000;
    }
  `,
  warning: css`
    :root {
      --warning-bg-color: #faa05a;
      --warning-color: #fff;
      --warning-border: 1px solid transparent;
      --warning-hover-color: #e19457;
      --warning-active-color: #ef9a56;
    }
  `,
  myPelete: localStorage.getItem('dark-mode') ? DarkModeCSS : LightModeCSS,
};

export function changeTheme(value: 'dark' | 'light') {
  const themeService = Container.get(DynamicCssService);
  const localStorage = Container.get(LocalStorageService);
  if (value === 'dark') {
    localStorage.update('dark-mode', true);
    palettes.myPelete = DarkModeCSS;
  } else {
    localStorage.remove('dark-mode');
    palettes.myPelete = LightModeCSS;
  }

  themeService.changeStyle(palettes);
}

// css`
/* :root { */
/* NEW THEME */

/* --global-color: rgb(3, 25, 63);
   --global-background: #f7f7f7;
   --global-background-image: linear-gradient(#ffffff, #e7e7e7);
   --global-dropdown-menu-bg: var(--global-background, white);
   --card-list-bg-color: #fcfcfc;
   --card-container-bg-color: #f0f0f0;
   --notification-icon-fill: #44a7ef;
   --menu-profile-border-color: #949494; */

/* --global-background-radial-0: #f7f7f7;
      --global-background-radial-100: #ffffff; */
/* NEW THEME END*/

/* OLD THEME */
/* --global-color: white;
   --global-background: #292c30;
   --global-background-image: linear-gradient(#292c30, #24292f);
   --menu-profile-border-color: white;
   --global-dropdown-menu-bg: white;
   --card-list-bg-color: #e2e4e6;
   --card-container-bg-color: #fff; */
/* OLD THEME END */

/* --tabs-menu-hover-color: rgba(255, 255, 255, 1);
   --bx-dropdown-text-color: white; */
/* --bx-dropdown-background: var(--global-background, 'rgb(36, 41, 47)'); */
/* --cds-text-01: var(--bx-dropdown-text-color); */
/* --avatar-size: 1.7rem;
   --avatar-count: 5; */

/* linear-gradient(#aeb0b3, #ffffff) */
/* } */
//  `
